






















































































import { Component, Provide, ProvideReactive, Vue } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'
import { TriggeredReferral } from '@/api/model/triggered-referral'
import { TriggeredReferralAPI, RealworksKenmerkAPI } from '@/api/backend-client'
import { InputSelectOption } from '@/helpers/options'
import { escapeHtml } from '@/helpers/html'

@Component
export default class CreateAutoLeadFormPopout extends Vue {
    visible: boolean = false
    saving: boolean = false
    currentStep: number = 1
    triggeredReferral: TriggeredReferral = null
    triggeredReferralExists: boolean = false
    @ProvideReactive() loadingKenmerken: boolean = true
    @ProvideReactive() kenmerken: InputSelectOption[] = []

    async open() {
        this.triggeredReferral = TriggeredReferral.fromData({
            id: uuid(),
            company: this.$currentCompany,
            active: true,
            maxDaysForExistingReferrals: 7,
        })
        this.triggeredReferralExists = false
        this.reload()
        this.currentStep = 1
        this.visible = true
    }

    async openWithExisting(triggeredReferral: TriggeredReferral) {
        this.triggeredReferral = await TriggeredReferralAPI.get(triggeredReferral.id, true)
        this.triggeredReferralExists = true
        this.reload()
        this.currentStep = 1
        this.visible = true
    }

    close() {
        this.visible = false
    }

    async save(): Promise<void> {
        try {
            this.saving = true
            if (!this.triggeredReferralExists) {
                await TriggeredReferralAPI.create(this.triggeredReferral)
            } else {
                await TriggeredReferralAPI.update(this.triggeredReferral.id, this.triggeredReferral)
            }
            this.$emit('save')
            this.close()
        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        } finally {
            this.saving = false
        }
    }

    previousStep(): void {
        this.currentStep--
    }

    nextStep(): void {
        if (this.currentStep <= 3) {
            this.currentStep++
        }
    }

    async reload(): Promise<void> {
        this.loadKenmerken()
    }

    async loadKenmerken() {
        this.loadingKenmerken = true

        const kenmerken = await RealworksKenmerkAPI.getAll()
        this.kenmerken = kenmerken
            .map(kenmerk => ({
                label: kenmerk.omschrijving,
                value: kenmerk.id.toString(), // cast to string because API expects a string
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingKenmerken = false
    }

    @Provide()
    kenmerkLabel(kenmerkId: string): string {
        const kenmerk = this.kenmerken.find(kenmerkOption => kenmerkOption.value === kenmerkId)
        if (kenmerk) {
            return `${kenmerkId} - ${kenmerk.label}`
        }

        return `${kenmerkId}`
    }
}
